import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/purple-post/post';

export default {
  getAll(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/resident${queryString}`);
  },
  getPost(id) {
    return axios.get(`${base}/single/${id}`);
  },
  deletePost(id) {
    return axios.delete(`${base}/delete/${id}`);
  },
  getRestrictionStatus() {
    return axios.get('/api/v1/purple-post/digital-mail-restrictions/me');
  },
};
